<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản đến ủy quyền
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class="leftSection margin-left-10">
                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                    <el-button
                      size="medium"
                      @click="chosenFileType"
                      type="primary">
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export"></i>
                        <span>&nbsp;KẾT XUẤT</span>
                      </div>
                    </el-button>
                  </el-tooltip>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
<!--                    <div-->
<!--                      class="flex-row flex-left__top margin-right-10 txt-center custom-label__input fix-width__large"-->
<!--                    >-->
<!--                      <span class="label-input width__auto"-->
<!--                      >Ngày chuyển:-->
<!--                      </span>-->
<!--                      <el-date-picker-->
<!--                        v-model="sendTimeRange"-->
<!--                        type="daterange"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="right"-->
<!--                        :clearable="false"-->
<!--                        @change="filterBySendTime"-->
<!--                      >-->
<!--                      </el-date-picker>-->
<!--                    </div>-->
                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày chuyển:
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromSendTime"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterBySendTime"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toSendTime"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterBySendTime"
                      ></el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <vbden-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    <span class="stt margin-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>

                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('sendTime')"
                  >
                    Thời gian chuyển
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'sendTime'"
                    />
                  </div>

                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left"
                    @click="doSort('senderName')"
                  >
                    Người chuyển
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'senderName'"
                    />
                  </div>

                  <!--
                  <div class="theTitle theTitle__lv3 flex-row flex__right padding-left-10">
                    Hạn xử lý
                    <i class="arrange-icon el-icon-d-caret" />
                  </div>
                  -->
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in incomingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <!-- <el-checkbox
                                v-model="checkAll"
                                class="select-doc margin-left-10 flex-row flex__center margin-top-10"
                              /> -->
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                          <fileTypeImage
                            :fileExtention="item.fileExtention"
                            class="clickable"
                            @click.native.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DEN
                              )
                            "
                          />
                          <!-- <i class="fas fa-file color__silver"></i> -->
                          <!-- {{item}} -->
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">{{ item.quote }}</div>
                          <div class="tt_2 flex-row flex__left">
                            <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>

                            <el-tag
                              v-if="isShowPriority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                          item.docDate
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv2 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <quahan-time :time="item.sendTime"></quahan-time>
                      </div>

                      <div
                        class="theTitle__lv2 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__left">
                          <displayPeople :name="item.senderName"/>
                        </div>
                      </div>

                      <div class="theQuickAction flex-row flex__right">
                        <el-tooltip content="Thu hồi" placement="top">
                          <i
                            @click.stop="thuHoi(item)"
                            class="action-icon bgAmbient__red clickable fas fa-undo"
                          ></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">
                      Không có dữ liệu
                    </div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>

        <thuHoiDialog
          :isOpen="isOpenThuHoiDialog"
          :vbIncomingProcessId="selectedDoc.vbDocUserVbDocProcessId"
          :nextStep="null"
          v-if="isEnableThuHoiDialog"
          @dialogClosed="isEnableThuHoiDialog = false"
          @closeDialog="
            (isOpenThuHoiDialog = false), (isEnableThuHoiDialog = false)
          "
          @success="vbIncomingProcessThuHoiSuccess"
        />
        <!--      hoang chosen file type-->
        <chosen-file-type-dialog
          v-if="isOpenChosenFileTypeDialog"
          @closeDialog="isOpenChosenFileTypeDialog= false"
          @exportResult="exportResult"
          :is-open="true">
        </chosen-file-type-dialog>
      </div>
    </template>
  </listTemplate>
</template>
<script>
  import buildShortNameFilter from "../../filters/buildShortNameFilter";
  import InfiniteLoading from "vue-infinite-loading";
  import dateFormatter from "../../filters/dateFormatter";
  import constants from "../../constants";
  import listTemplate from "../common/list";
  import headerTemplate from "../../components/header/main-header.vue";
  import searchTemplate from "../common/search";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import vbDenMixin from "./vbDenMixin";
  import utils from "../../services/utils";
  import vbIncomingProcessService from "../../services/vbIncomingProcessService";
  import VbdenAdvanceSearchDialog from "./components/vbden-advance-search-dialog";
  import QuahanTime from "../doc-out/quahan-time";
  import chosenFileTypeDialog from "../doc-out/chosenFileTypeDialog";

  export default {
    name: "vbDenUyQuyenIndex",
    components: {
      chosenFileTypeDialog,
      QuahanTime,
      VbdenAdvanceSearchDialog,
      InfiniteLoading,
      listTemplate,
      headerTemplate,
      searchTemplate,
      VuePerfectScrollbar,
      subHeader: () => import("../../components/main/sub-header.vue"),
      createDialog: () => import("./components/CreateDialog.vue"),
      filterByStatus: () => import("./components/filter-by-status-header.vue"),
      SortCaret: () => import("../doc-out/SortCaret"),
      thuHoiDialog: () => import("./components/thuHoiDialog"),
      fileTypeImage: () => import("../common/FileTypeImage"),
      displayPeople: () => import("../common/displayPeople.vue")
    },

    filters: {dateFormatter, buildShortNameFilter},
    mixins: [vbDenMixin],

    data() {
      return {
        isOpenChosenFileTypeDialog:false,
        ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
        INCOMING_PROCESS_STATUS: constants.INCOMING_PROCESS_STATUS,
        INCOMING_DOC_STATUS: constants.INCOMING_DOC_STATUS,
        isOpenThuHoiDialog: false,
        isEnableThuHoiDialog: false,
        selectedDoc: null,
      };
    },

    computed: {
      relationType() {
        return constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
      }
    },

    watch: {
      isOpenThuHoiDialog(newValue) {
        newValue && (this.isEnableThuHoiDialog = newValue);
      },

      isEnableThuHoiDialog(newValue) {
        !newValue && (this.selectedDoc = null);
      }
    },

    created() {
      this.sort = this.$route.query.sort || "sendTime";
      this.order = this.$route.query.order || "desc";
      this.initQuery();
      // this.initSendTimeRange();
      this.setDefaultDocDateRange();
      this.filterBySendTime();
    },

    methods: {
      isVbDienTu(item){
        if(item.eFlag&&item.eFlag==='1'){
          return true;
        }else {
          return false;
        }
      },
      chosenFileType(){
        this.isOpenChosenFileTypeDialog = true
      },
      exportResult(item) {
        this.isOpenChosenFileTypeDialog = false
        this.exportSearchResult(item,'VB_DEN_UY_QUYEN')
      },
      advanceSearch(event) {
        this.advanceSearch_(event);
        this.initSendTimeRange();
        this.doSearch();
      },

      loadNextVbIncomingProcesses() {
        vbIncomingProcessService
          .findAll(
            {parentId: this.vbIncomingProcessId},
            {page: 0, size: 1000, order: "updateTime,desc"}
          )
          .then(response => (this.nextVbIncomingProcesses = response.data));
      },

      viewDetail(item) {
        let query = utils.merge(this.$route.query, {
          vbDocProcessId: item.vbDocUserVbDocProcessId
        });
        let params = utils.merge(this.$route.params, {
          id: item.vbIncomingDocUserViewKey.id
        });
        this.$router.push({
          name: "vbDenUyQuyenDetail",
          params: params,
          query: query
        });
      },

      thuHoi(item) {
        this.selectedDoc = item;
        vbIncomingProcessService
          .findAll(
            {parentId: item.vbDocUserVbDocProcessId},
            {page: 0, size: 1000, order: "updateTime,desc"}
          )
          .then(response => {
            let nextVbIncomingProcesses = response.data;
            if (nextVbIncomingProcesses && nextVbIncomingProcesses.length > 0) {
              this.isOpenThuHoiDialog = true;
            } else {
              this.$message.warning(
                "Không thể thu hồi văn bản do chưa chuyển xử lý!"
              );
            }
          });
      },

      vbIncomingProcessThuHoiSuccess() {
        this.isOpenThuHoiDialog = false;
        this.doSearch();
      }
    }
  };
</script>
<style scoped>
  /*#searchBox {*/
  /*  position: relative;*/
  /*  width: 100%;*/
  /*}*/

  /*.advance-search {*/
  /*  font-size: 17px;*/
  /*  color: #005eb1;*/
  /*  position: absolute;*/
  /*  right: 5%;*/
  /*  top: 50%;*/
  /*  transform: translateY(-50%);*/
  /*}*/

  /*.icon-very__small {*/
  /*  height: 14px;*/
  /*  padding-top: 4px;*/
  /*}*/

  /*.icon-info {*/
  /*  background-color: #f0c330;*/
  /*  border-radius: 50%;*/
  /*  width: 15px;*/
  /*  height: 15px;*/
  /*  margin-top: -1px;*/
  /*  margin-left: 2px;*/
  /*}*/
  .eIcon{
    border: solid 1px #007aff;
    border-radius: 2px;
    padding: 0px 3px;
    font-size: 11px;
    color: goldenrod;
    margin-left:2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenUyQuyenIndex.vue